import * as React from 'react'
import Content from './content'
import './style.scss'

interface IProps {
  alwaysHideContent?: boolean
}

interface IState {
  loading: boolean
}

const defaultState: IState = {
  loading: true
}

const Landing: React.FC<IProps> = (props: IProps) => {
  const [state, setState] = React.useState<IState>(defaultState)
  React.useEffect(() => {
    window.scrollTo(0, 0)
    // simulate loading
    const timer = setTimeout(() => setState({ loading: false }), 1000)
    return () => clearTimeout(timer)
  })

  return (
    <div className="splash-container">
      {!props.alwaysHideContent && <Content loading={state.loading} />}
    </div>
  )
}

export default Landing



// WEBPACK FOOTER //
// ./src/pages/Landing/index.tsx